


export const InsuranceListPage = () => {
  return (<></>)
}